import 'css-chunksrc/client/scenes/resourceEdition/assignCostProfileToResource/costProfiles/costProfile/styles.scss';export default {
  "costProfile": "_costProfile_1gs4j_1",
  "contextualMenu": "_contextualMenu_1gs4j_6",
  "row": "_row_1gs4j_13",
  "icon": "_icon_1gs4j_21",
  "col": "_col_1gs4j_29",
  "name": "_name_1gs4j_34",
  "cost": "_cost_1gs4j_1",
  "removeIcon": "_removeIcon_1gs4j_52"
};